import React, { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import { Col, Container } from 'react-bootstrap'
import { Box, MainHeading, SpanStyled } from '../../../ui/Elements'
import { ArrowBtn, HeroBg, Instagram, LinkedIn, Phone, Twitter, Vision2030, Whatsapp, WhatsAppCtnt, WhatsIcon, WhatsIconBtn } from '../../../ui/AllImages'
import { useTranslation } from 'react-i18next'
import { ButtonWithIcon, ButtonWithIcon2, ContactButton, ContactButtonHref } from '../../../ui/CustomElements'
import { Animate } from 'react-simple-animate'
import i18n from '../../../Languages/INEXT'
const Banner = () => {
    const { t } = useTranslation();
    const sectionRef = useRef(null);
    const [isVisible, setIsVisible] = useState(false);
    const WhatsApp = () => {
        const phoneNumber = '+966505531205';
        const message = 'Hello, this is Al Asas';
        const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
        window.open(whatsappURL, '_blank');
    };
    const socialIcon = [
        
        {
            img: <Twitter />,
            link: 'https://x.com',
        },
        {
            img: <Instagram />,
            link: 'https://www.instagram.com/',
        },
        /* {
            img: <Tiktok />,
            link: 'https://www.tiktok.com/',
        },
        {
            img: <SnapChat />,
            link: 'https://snapchat.com/',
        }, */
        /* {
            img: <LinkedIn />,
            link: 'https://www.linkedin.com/',
        }, */
    ]
    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                // When visible, set to true
                if (entry.isIntersecting) {
                    setIsVisible(true);
                    observer.disconnect(); // run animation once
                }
            },
            {
                threshold: 0.2, // 20% of section visible triggers the animation
            }
        );

        if (sectionRef.current) {
            observer.observe(sectionRef.current);
        }

        return () => observer.disconnect();
    }, []);
    
    // const start = { clipPath: "inset(0 100% 0 0)" };
    const start = i18n.language === "ar"
    ? { clipPath: "inset(0 0 0 100%)" }   // Arabic → reveal right → left
    : { clipPath: "inset(0 100% 0 0)" };  // English → reveal left → right
    const end = { clipPath: "inset(0 0% 0 0)" };
    // const start = { width: "0", transformOrigin: "left" };
    // const end = { width: "100%", transformOrigin: "left" };
    // const start = { opacity: 0, transform: 'translateY(-40px)' };
    // const end = { opacity: 1, transform: 'translateY(0)' };
    const start2 = { opacity: 0, transform: 'translateY(-5px)' };
    const end2 = { opacity: 1, transform: 'translateY(0)' };
    const start3 = { opacity: 0, transform: 'translateY(-20px)' };
    const end3 = { opacity: 1, transform: 'translateY(0)' };
    return (
        <>
            <BannerWapper className='container-fluid common-space bannerFluid'  id='home' ref={sectionRef}>
                <Container>
                    <Box className='bannerRow row'>
                        <Col md={12} className="bannerColMain">
                            <Box className='bannerContent'>
                                
                                <Animate
                                    play={isVisible}
                                    duration={1}
                                    // delay={.5}
                                    

                                    start={start}
                                    end={end}
                                >
                                    <MainHeading className='main-heading main-heading-banner gradientHeading' size="64px" lh="1.1" color="var(--white)">
                                        {t('BannerHeading')}
                                    </MainHeading>
                                </Animate>
                                <Animate
                                    play={isVisible}
                                    duration={1}
                                    delay={.8}
                                    start={start2}
                                    end={end2}
                                >
                                    <SpanStyled className='d-flex align-items-center gap-2 flex-sm-wrap mb-4 bannerTxt' color="var(--white)">
                                        {t('BannerTxt')}
                                    </SpanStyled>
                                </Animate>
                                <Animate
                                    play={isVisible}
                                    duration={1}
                                    delay={1.2}
                                    start={start2}
                                    end={end2}
                                >
                                    <SpanStyled className='d-flex align-items-center gap-2 flex-sm-wrap'>
                                        <ContactButton icon={Phone} label={t('BookYourConsultation')} onClick={WhatsApp} />
                                        {/* <WhatsAppCtnt className='drWhatsBtn cursor-pointeer' onClick={WhatsApp} /> */}
                                        {/* <ButtonWithIcon2 className='drWhatsBtn cursor-pointeer' bg="#25D366" icon={WhatsIconBtn} label={t('whatsapp')} onClick={WhatsApp} /> */}
                                        
                                    </SpanStyled>
                                </Animate>
                            </Box>
                            <Box className='socialRowBanner'>
                                {/* <Box className='Social-links'>
                                    {
                                        socialIcon.map((list, key) => (
                                            <a href={list.link} target="_blank" key={key} className='contact-links'>
                                                {list.img}
                                            </a>
                                        ))
                                    }
                                </Box> */}
                                <Box className='partnerLogo'>
                                    <Animate
                                        play={isVisible}
                                        duration={1}
                                        delay={1.2}
                                        start={start3}
                                        end={end3}
                                    >
                                    <img src={Vision2030} alt="vision" />
                                    </Animate>
                                </Box>
                            </Box>

                        </Col>
                        
                    </Box>
                </Container>
            </BannerWapper>
        </>
    )
}
const BannerWapper = styled.section`
    padding-bottom: 2px;
    background-image: url(${HeroBg});
    background-size: cover;
    background-position: top center;
    /* height: 780px; */
    padding-top: 100px;
    & > .container{
        .bannerColMain{
            height: auto;
            display: flex;
            background-repeat: no-repeat;
            background-size: cover;
            background-position: left center;
            border-radius: 16px;
            overflow: hidden;
            padding-bottom: 150px;
            .bannerContent{
                display: flex;
                width: 660px;
                min-width: 660px;
                flex-wrap: wrap;
                flex-direction: column;
                padding-top: 107px;
                padding-left: 110px;
                .main-heading-banner{
                    font-family: var(--familyRbtFlex);
                    font-weight: var(--extraBold);
                    font-size: 64px;
                    margin-bottom: 10px;
                }
                .bannerTxt{
                    font-family: var(--familyRbtFlex);
                    font-weight: var(--semiBold);
                    
                    padding-left: 0;
                    font-size: 20px;

                }
                
            }
            .socialRowBanner{
                display: flex;
                width: 100%;
                justify-content: flex-end;
                align-items: flex-end;
                padding: 60px 110px 0 110px;
                .Social-links{
                    display: flex;
                    gap: 20px;
                    width: fit-content
                }
            }
        }
        
    }
    .bannerRow{
        padding: 0px 0px 0 0px;
        align-items: center;
        /* margin-left: 0;
        margin-right: 0; */
    }
    .bannerImgContainer{
        padding-top: 20px;
    } 
    .reveal-mask{
    overflow: hidden;
    }

    .reveal-content{
    width: 100%;
    }
    body.rtl &{
        & > .container{
            .bannerColMain{
                direction: ltr;
                
                .bannerContent{
                    direction: rtl;
                    /* padding-top: 150px;
                    padding-left: 0;
                    padding-right: 168px; */
                    .main-heading-banner{
                        font-family: var(--arSemiBold);
                        font-weight: var(--semiBold);
                        font-size: 72px;
                        margin-bottom: 10px;
                        line-height: 1.3;
                    }
                    .bannerTxt{
                        font-family: var(--arSemiBold);
                        /* padding-left: 50px; */
                        padding-right: 0;

                    }
                }
            }
        }
            
        
        .bannerRow{
            padding: 0px 0px 0 0px;
            align-items: center;
            
        }
        
        .bannerCol1{
            padding-bottom: 60px !important;
        }
    }
    @media (max-width: 1399px) {
        .bannerRow{
            padding-left: 0;
            padding-right: 0;
        }
        body.rtl &{
            .bannerRow{
                padding: 0px 0px 0 0px;
                
            }
        }
    }
    @media (max-width: 1199px) {
        display: flex;
        align-items: center;
        padding-bottom: 0px;
        /* .main-heading{
            font-size: 55px;
        } */
    }
    @media (max-width: 991px) {
        padding-top: 84px;
        height: auto;
        /* .main-heading{
            font-size: 45px;
            text-align: center;
        } */
        .bannerSubTxt{
            font-size: 22px;
            text-align: center;
            margin-bottom: 30px;
        }
        .bannerSubDetailTxt{
            text-align: center;
            display: inline-block;
        }
        .bannerImgContainer{
            justify-content: center !important;
            padding-top: 0px;
        }
        .bannerCol1{
            padding-bottom: 30px !important;
        }
        .socialRowBanner{
            display: none !important;
        }
        .container{
            .bannerColMain{
                height: auto;
                .bannerContent{
                    padding: 50px 0 0 0;
                    width: 100%;
                    min-width: 100%;
                    .main-heading-banner {
                        /* font-family: var(--familyRbtFlex); */
                        /* font-weight: var(--semiBold); */
                        font-size: 50px;
                        margin-bottom: 30px;
                    }
                }
                .socialRowBanner{
                    padding: 40px 0px 0 0px;
                    .Social-links{
                        display: flex;
                        gap: 20px;
                        width: fit-content
                    }
                }
            }
        }
        
        
        body.rtl &{
            
            .container{
                .bannerColMain{
                    
                    .bannerContent{
                        
                        .main-heading-banner {
                            font-size: 40px;
                            
                        }
                    }
                    
                }
            }
        }
    }
    @media (max-width: 767px) {
        & > .container{
            .bannerColMain{
                /* height: 440px; */
                /* background-size: 1190px 510px; */
                /* background-position: left -40px top -10px; */
                padding-bottom: 80px;
                .bannerContent{
                    width: 100%;
                    /* padding-top: 50px; */
                    /* padding-left: 90px; */
                    .main-heading-banner {
                        font-size: 40px;
                        margin-bottom: 30px;
                    }
                }
            }
        }
        body.rtl &{
            & > .container{
                .bannerColMain{
                    
                    .bannerContent{
                        /* padding-top: 70px;
                        padding-right: 9px; */
                        
                    }
                }
            }
             
        }
    }
    @media (max-width: 640px) {
        padding-top: 80px;
        body.rtl &{
            .main-heading{
                font-size: 35px;
            }
            .bannerSubTxt{
                font-size: 24px;
            }
        }
    }
    @media (max-width: 575px) {
        & > .container{
            .bannerColMain{
                /* background-position: left -110px top -10px; */
                .bannerContent{
                    width: 100%;
                    /* padding-top: 50px;
                    padding-left: 10px;
                    padding-right: 10px; */
                }
                .socialRowBanner{
                    flex-wrap: wrap;
                    gap: 20px;
                }
            }
        }
    }

    @media (max-width: 480px) {
        
        
        
        body.rtl &{
            
            .container{
                .bannerColMain{
                    
                    .socialRowBanner{
                        justify-content: end;
                    }
                }
            }
        }
    }

    
    @media (max-width: 350px) {
        & > .container{
            .bannerColMain{
                .bannerContent{
                    padding-left: 0px;
                    padding-right: 0px;
                }
            }
        }
    }
`
export default Banner
